import { onSnapshot, type QuerySnapshot } from "firebase/firestore";
import { planTablesCol } from "@/features/seating/firestore-paths";
import { createSharedSubscription } from "@/lib/firestore/createSharedSubscription";
import { parsePlanScopedKey } from "@/lib/firestore/subscription-keys";
import { toMillis } from "@/lib/timestamps";
import type { Table } from "@amazing-wedding/shared-types";

function parseTables(snap: QuerySnapshot): Table[] {
  const rows: Table[] = [];
  snap.forEach((d) => {
    const data = d.data() as Omit<Table, "id">;
    rows.push({ id: d.id, ...data, seatMap: data.seatMap ?? [] });
  });
  rows.sort((a, b) => toMillis(a.createdAt) - toMillis(b.createdAt));
  return rows;
}

export const tablesSubscription = createSharedSubscription<Table[]>({
  getDefault: () => [],
  attach: (key, setSnapshot) => {
    const scoped = parsePlanScopedKey(key);
    if (!scoped) {
      setSnapshot({ data: [], loading: false });
      return () => {};
    }

    setSnapshot({ data: [], loading: true });
    return onSnapshot(
      planTablesCol(scoped.weddingId, scoped.planId),
      (snap) => {
        setSnapshot({ data: parseTables(snap), loading: false });
      },
      () => setSnapshot({ data: [], loading: false }),
    );
  },
});
